import React, { useState } from "react";
import styled from "styled-components";
import { projects } from "../../data/constants";
import ProjectCard from "../cards/ProjectCard";

const Container = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 0 16px;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ToggleButtonGroup = styled.div`
  display: flex;
  border: 1.5px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primary};
  font-size: 16px;
  border-radius: 12px;
  font-weight: 500;
  margin: 22px 0;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const ToggleButton = styled.div`
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  will-change: background; // Optimize transition
  transition: background 0.3s ease-in-out; // Simplified transition
  &:hover {
    background: ${({ theme }) => theme.primary + 20};
  }
  @media (max-width: 768px) {
    padding: 6px 8px;
    border-radius: 4px;
  }
  ${({ active, theme }) =>
    active &&
    `
      background: ${theme.primary + 20};
    `}
`;

const Divider = styled.div`
  width: 1.5px;
  background: ${({ theme }) => theme.primary};
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
`;

const LoadMoreButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.text_primary};
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  transition: background 0.3s ease-in-out;
  &:hover {
    background: ${({ theme }) => theme.primary + 20};
  }
`;

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");
  const [visibleProjects, setVisibleProjects] = useState(6); // Initial limit

  return (
    <Container id="Projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc style={{ marginBottom: "40px" }}>
          I have worked on a wide range of projects. Here are some of my projects.
        </Desc>
        <ToggleButtonGroup>
          <ToggleButton active={toggle === "all"} onClick={() => setToggle("all")}>
            All
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "python project"} onClick={() => setToggle("python project")}>
            PYTHON PROJECT'S
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "java project"} onClick={() => setToggle("java project")}>
            JAVA PROJECT'S
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "artificial intelligence"} onClick={() => setToggle("artificial intelligence")}>
            ARTIFICIAL INTELLIGENCE
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "machine learning"} onClick={() => setToggle("machine learning")}>
            MACHINE LEARNING
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === "cyber security"} onClick={() => setToggle("cyber security")}>
            CYBER SECURITY
          </ToggleButton>
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === "all"
            ? projects.slice(0, visibleProjects).map((project) => (
                <ProjectCard
                  key={project.id}
                  project={project}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                />
              ))
            : projects
                .filter((item) => item.category === toggle)
                .slice(0, visibleProjects)
                .map((project) => (
                  <ProjectCard
                    key={project.id}
                    project={project}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                  />
                ))}
        </CardContainer>
        {visibleProjects < projects.length && (
          <LoadMoreButton onClick={() => setVisibleProjects(visibleProjects + 6)}>
            Load More
          </LoadMoreButton>
        )}
      </Wrapper>
    </Container>
  );
};

export default Projects;